<script>
import Layout from '@layouts/main'
import LoginSidebar from '@components/login-sidebar'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'

export default {
  components: { Layout, LoginSidebar },
  metaInfo: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  data() {
    return {
      username: '',
      password: '',
      authError: null,
      valid: false,
      tryingToLogIn: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [v => !!v || 'Password is required'],
    }
  },
  computed: {
    placeholders() {
      return process.env.NODE_ENV === 'production'
        ? {
            username: 'user@example.com',
            password: 'password',
          }
        : {
            username: 'Use "admin" to log in with the mock API',
            password: 'Use "password" to log in with the mock API',
          }
    },
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.authError = null
      return this.logIn({
        username: this.username,
        password: this.password,
      })
        .then(token => {
          this.tryingToLogIn = false

          // Redirect to the originally requested page, or to the home page
          this.$router.push(this.$route.query.redirectFrom || { name: 'home' })
        })
        .catch(error => {
          this.tryingToLogIn = false
          this.authError = error
        })
    },
  },
}
</script>

<template>
  <Layout row class="pa-0">
    <LoginSidebar />

    <v-flex xs7 class="main">
      <v-layout fill-height justify-center>
        <v-flex sm7 class="form">
          <h2>Log in</h2>
          <v-form
            ref="form"
            v-model="valid"
            class="form"
            lazy-validation
            @submit.prevent="tryToLogIn"
          >
            <v-text-field
              v-model="username"
              name="username"
              :rules="emailRules"
              label="Email or username"
              required
            ></v-text-field>
            <v-text-field
              v-model="password"
              :rules="passwordRules"
              name="password"
              type="password"
              label="Password"
              required
            ></v-text-field>
            <v-btn
              depressed
              block
              primary
              :disabled="!valid"
              class="btn-blue"
              type="submit"
            >
              <BaseIcon v-if="tryingToLogIn" name="sync" spin />
              <span v-else>Log in</span>
            </v-btn>
          </v-form>
          <p v-if="authError">There was an error logging in to your account.</p>
          <BaseLink name="forgotPassword">Forgot your password?</BaseLink>

          <hr />

          <p>Don't have an account?</p>
          <v-btn
            outline
            block
            class="btn-blue-outline"
            :to="{ name: 'register' }"
          >
            <span>Create your account</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </Layout>
</template>

<style lang="scss">
@import '@design';

.main {
  padding: 100px 0;
  background-color: #f5f9fc;
}
</style>
